import { render, staticRenderFns } from "./SearchOnlyPeriod2.vue?vue&type=template&id=126d3e1c"
import script from "./SearchOnlyPeriod2.vue?vue&type=script&lang=js"
export * from "./SearchOnlyPeriod2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports